import {Typography} from '@material-ui/core'
import React from 'react'
import resumeData from '../../utils/resumeData'

import './Footer.css'

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-left">
        <Typography className="footer-name">{resumeData.name}</Typography>
      </div>
      <div className="footer-right">
        <Typography className="footer-copyright">
          Site is Developed for Educational Purposes
          <br />
          Clone idea from{' '}
          <a href="http://www.tavonline.net/" rel="noreferrer" target="_blank">
            Tavonline
          </a>
          .
          <br />
          <a href="http://www.freepik.com">
            Background image is Designed by rawpixel.com / Freepik
          </a>
        </Typography>
      </div>
    </div>
  )
}

export default Footer
